import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { likeArtwork, unlikeArtwork, isLiked } from '../services/likeService';

export const useLike = (artworkId: string, artistId: string) => {
  const { user } = useAuth();
  const [isLikedByUser, setIsLikedByUser] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkLike();
  }, [user, artworkId]);

  const checkLike = async () => {
    if (!user) return;
    const liked = await isLiked(user.id, artworkId);
    setIsLikedByUser(liked);
  };

  const toggleLike = async () => {
    if (!user || loading) return;

    setLoading(true);
    try {
      if (isLikedByUser) {
        await unlikeArtwork(user.id, artworkId);
        setIsLikedByUser(false);
      } else {
        await likeArtwork(user.id, user.name, artworkId, artistId);
        setIsLikedByUser(true);
      }
    } catch (error) {
      console.error('Error toggling like:', error);
    } finally {
      setLoading(false);
    }
  };

  return { isLikedByUser, toggleLike, loading };
};